export default __webpack_public_path__ + "static/media/11.2d78dd62.png";